import { Injectable } from '@angular/core';
import { SentryService } from './sentry.service';

@Injectable({
  providedIn: 'root'
})
export class CookieService {

  constructor(private sentryService: SentryService) {
  }

  set(key: string, value: string): void;
  set(key: string, value: string, expires: Date): void;
  set(key: string, value: string, expires?: Date): void {
    let cookieValue = `${key}=${value}`;
    if (expires) {
      cookieValue += `;expires='${expires.toUTCString()}'`;
    }
    document.cookie = cookieValue;
  }

  setWithExpiryInMiliseconds(key: string, value: string, expires: number) {
    const expireDate = new Date();
    const time = expireDate.getTime() + expires;
    expireDate.setTime(time);

    this.set(key, value, expireDate);
  }

  get(key: string): string {
    try {
      const decodedCookie: string = decodeURIComponent(document.cookie);
      const pairs: string[] = decodedCookie.split(/;\s*/);

      const prefix = `${key}=`;
      for (const pair of pairs) {
        if (pair.indexOf(prefix) == 0) {
          return pair.substring(prefix.length);
        }
      }
      return '';
    } catch (error) {
      this.sentryService.errorHandling(error, 'cookie-service', error ? error.message : '');
    }
  }
}
